import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { type FlowNodeControl, defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

const encodingItems: FlowNodeControl.Configs.Selection.SelectionItem[] = [
    { label: 'UTF-8', value: 'utf-8' },
    { label: 'ASCII', value: 'ascii' },
    { label: 'Latin1', value: 'latin1' },
    { label: 'UTF-16 LE', value: 'utf16le' },
    { label: 'Base64', value: 'base64' },
    { label: 'Hex', value: 'hex' },
];

export const fileWriteUiNodeSpec: NodeSpec<NodeCfg<'fileWrite'>> = {
    requiredSockets: [ 'trigger', 'filePath', 'fileContents' ],
    cfg: () => ({
        controlValues: { encoding: 'utf-8', append: false, createIfNotExists: true },
        id: getUID(),
        kind: 'fileWrite',
        disabled: false,
        width: 210,
    }),
    controls: nodeCfg => ({
        encoding: defineControlOpts({
            cfg: {
                items: encodingItems,
                kind: 'selection',
                label: 'Encoding',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.encoding,
        }),
        append: defineControlOpts({
            cfg: {
                kind: 'boolean',
                label: 'Append',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.append,
        }),
        createIfNotExists: defineControlOpts({
            cfg: {
                kind: 'boolean',
                label: 'Create if not exists',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.createIfNotExists,
        }),
    }),
    inputs: () => ({
        trigger: {
            socket: 'event',
            label: 'Trigger',
        },
        filePath: {
            socket: 'string',
            label: 'File Path',
        },
        fileContents: {
            socket: 'string',
            label: 'File Contents',
        },
    }),
    kindLabel: 'File Write',
    nodeCategory: 'file',
    outputs: () => ({
        next: {
            socket: 'event',
            label: 'Next',
        },
    }),
    validator: () => true,
};
